import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { treatmentPlanV3Actions } from '../../../../../../store';

import type { AppDispatch } from '../../../../../../store';

export default function useFetchTreatmentPlanV3FamilyPage() {
  const dispatch = useDispatch<AppDispatch>();
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const { getAccessTokenSilently } = useAuth0();

  const fetchPage = useCallback(() => {
    if (!treatmentPlanId) return;

    dispatch(
      treatmentPlanV3Actions.getTreatmentPlanV3FamilyPage({
        treatmentPlanId,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, treatmentPlanId]);

  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  return { retry: fetchPage };
}
